// src/ArtifactActions/ArtifactActions.tsx
import * as React from "react";
import Button from "@cloudscape-design/components/button";
import ButtonDropdown from "@cloudscape-design/components/button-dropdown";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Icon from "@cloudscape-design/components/icon";
import { jsx, jsxs } from "react/jsx-runtime";
var ArtifactActions = ({ onDownloadCSV, onDownloadPDF, onDownloadMarkdown, onView, onExpand, logger }) => {
  const downloadItems = React.useMemo(() => {
    const items = [];
    if (onDownloadPDF) {
      items.push({ text: "PDF", id: "pdf", disabled: false });
    }
    if (onDownloadCSV) {
      items.push({ text: "CSV", id: "csv", disabled: false });
    }
    if (onDownloadMarkdown) {
      items.push({ text: "Markdown", id: "markdown", disabled: false });
    }
    return items;
  }, [onDownloadPDF, onDownloadCSV, onDownloadMarkdown]);
  const handleDownloadClick = React.useCallback(
    ({ detail }) => {
      if (detail.id === "pdf" && onDownloadPDF) {
        logger?.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "download-pdf-button"
          }
        });
        onDownloadPDF();
      } else if (detail.id === "csv" && onDownloadCSV) {
        logger?.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "download-csv-button"
          }
        });
        onDownloadCSV();
      } else if (detail.id === "markdown" && onDownloadMarkdown) {
        logger?.biMetric({
          metricName: "Click",
          value: 1,
          unit: "Count",
          dimensions: {
            ClickSelect: "download-markdown-button"
          }
        });
        onDownloadMarkdown();
      }
    },
    [onDownloadPDF, onDownloadCSV, onDownloadMarkdown, logger]
  );
  const hasDownloadOptions = downloadItems.length > 0;
  return /* @__PURE__ */ jsxs(SpaceBetween, { direction: "horizontal", size: "s", children: [
    onView && /* @__PURE__ */ jsx(Button, { variant: "normal", onClick: onView, children: "View" }),
    onExpand && /* @__PURE__ */ jsx(
      Button,
      {
        iconName: "expand",
        variant: "normal",
        onClick: () => {
          logger?.biMetric({
            metricName: "Click",
            value: 1,
            unit: "Count",
            dimensions: {
              ClickSelect: "fullscreen-button"
            }
          });
          onExpand();
        },
        children: "Fullscreen"
      }
    ),
    hasDownloadOptions && /* @__PURE__ */ jsxs(ButtonDropdown, { items: downloadItems, onItemClick: handleDownloadClick, children: [
      /* @__PURE__ */ jsx(Icon, { name: "download" }),
      " Download"
    ] })
  ] });
};
export {
  ArtifactActions
};
//# sourceMappingURL=index.js.map
